module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/apple-watch-prototyping-ideas.json
// module id = 1923
// module chunks = 272184818942850